import data from '../data';
import addToWishlistAction from '../actions/addToWishlist.action';
import removeFromWishlistAction from '../actions/removeFromWishlist.action';
import { debounce } from '../../js/debounce';
import { competitionPopup } from './competitionPopup';
import { wishTriggers } from '../main';
import { isNotNullOrUndef } from '../../js/helpers/isNotNullOrUndef';
const wishButtons = () => {
    competitionPopup.init();
    class WishButtonComponent extends HTMLElement {
        counter = null;
        constructor() {
            super();
            this.setActive = this.setActive.bind(this);
            this.setInactive = this.setInactive.bind(this);
        }
        connectedCallback() {
            this.counter = this.querySelector('[data-wish-counter]');
            this.dataset.active = data.products.some(({ sku, deletedFromMeta }) => !deletedFromMeta && sku === this.dataset.sku)
                ? '1'
                : '0';
            const debouncedHandler = debounce(this.clickHandler.bind(this));
            this.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                debouncedHandler();
            });
            this.subscribe(String(this.dataset.sku));
        }
        disconnectedCallback() {
            this.unsubscribe(String(this.dataset.sku));
        }
        attributeChangedCallback(name, oldValue, newValue) {
            this.unsubscribe(oldValue);
            this.subscribe(newValue);
        }
        static get observedAttributes() { return ['data-sku']; }
        clickHandler() {
            const productData = {
                id: this.dataset.id,
                sku: this.dataset.sku,
                title: this.dataset.title,
                handle: this.dataset.handle,
                image: isNotNullOrUndef(this.dataset.image3d) && this.dataset.image3d !== ''
                    ? this.dataset.image3d
                    : this.dataset.image,
                url: this.dataset.url,
                count: this.dataset.currentCount
            };
            if (this.dataset.active === '1') {
                removeFromWishlistAction(productData.sku);
            }
            else {
                addToWishlistAction(productData);
                competitionPopup.showPopup(this);
            }
        }
        setActive() {
            const count = parseInt(this.dataset.currentCount ?? this.counter?.innerHTML ?? '0');
            const strCount = String(count + 1);
            this.counter !== null && (this.counter.innerHTML = strCount);
            this.dataset.currentCount = strCount;
            this.dataset.active = '1';
        }
        setInactive() {
            const count = parseInt(this.dataset.currentCount ?? this.counter?.innerHTML ?? '0');
            const strCount = String(count - 1);
            this.counter !== null && (this.counter.innerHTML = strCount);
            this.dataset.currentCount = strCount;
            this.dataset.active = '0';
        }
        subscribe(sku) {
            wishTriggers.on(`list:${sku}:add`, this.setActive);
            wishTriggers.on(`list:${sku}:remove`, this.setInactive);
        }
        unsubscribe(sku) {
            wishTriggers.off(`list:${sku}:add`, this.setActive);
            wishTriggers.off(`list:${sku}:remove`, this.setInactive);
        }
    }
    window.customElements.define('component-wishlist-button', WishButtonComponent);
};
export default wishButtons;
